export const Errors = {
  EncryptionNotAvailable: "EncryptionNotAvailable",
  APIRequestFailed: "Failed to fetch", // this is part the provide error message from connect-es
  UnknownError: "UnknownError",
};
